import { Injectable } from '@angular/core';
import {
	Router, Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot
} from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DigitalLogService } from '../../services/sections/job/digital-log.service';
import { GlobalSettingsService } from '../../services/ui/global-settings.service';
import { FieldAttachmentFilter } from 'src/app/models/digital-log/field-attachment-filter';

@Injectable({
	providedIn: 'root'
})
export class FieldsAttachmentsResolver implements Resolve<Observable<any[]>> {

	constructor(
		private router: Router,
		private digitalLogService: DigitalLogService
	) { }
	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		GlobalSettingsService.isSecondaryLoaderLoading = true;
		activatedRouteSnapshot.data
		return this.digitalLogService
			.getFieldsAttachments(activatedRouteSnapshot.paramMap.get('token'), { displayFavoritesOnly: false, displayOnlyNoDocs: false, searchKeyword: null } as FieldAttachmentFilter)
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
